<template>
  <b-modal id="modal-cannot-delete-dir" header-class="warning">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div class=""> 
          <h5> {{$t('engine.filemanager.folder.cantDelete.lblTitle', languageEngine)}}</h5>
        </div>
        <div class="d-flex">
          <div class="mr-gd-1">
            <i class="fal fa-question-circle"></i>
          </div>
          <div
            @click="closeModal()"
            id="close-modal-limit"
            class="close-modal cursor-pointer"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>
    <template>
      <div>
        {{$t('engine.filemanager.folder.cantDelete.lblDetail', languageEngine)}}
      </div>
    </template>
    <template #modal-footer>
      <div class="float-right">
        <b-button variant="blue" @click="closeModal">{{$t('engine.common.btnClose', languageEngine)}}</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    })
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-cannot-delete-dir");
    }
  },
}
</script>